<h2 mat-dialog-title class="titre2">{{ 'USERS_MANAGEMENT.RESEND_INVITATIONS_COMPLETED' | translate }}</h2>
<mat-dialog-content>
    <p>{{ 'USERS_MANAGEMENT.INVITATIONS_RESENT_SUCCESSFULLY' | translate }}</p>
</mat-dialog-content>
<mat-dialog-actions align="end">
    <button mat-button color="warn" (click)="onClose()"
        class="px-4 py-2 btn-primary-novo">
        {{ 'USERS_MANAGEMENT.CLOSE' | translate }}
    </button>
</mat-dialog-actions>
